module.exports = __webpack_public_path__ + "static/img/IMG_20241028_170744.37d878d8.jpg";